import { render, staticRenderFns } from "./Budget4.vue?vue&type=template&id=391437a4&scoped=true"
import script from "./Budget4.vue?vue&type=script&lang=js"
export * from "./Budget4.vue?vue&type=script&lang=js"
import style0 from "./Budget4.vue?vue&type=style&index=0&id=391437a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391437a4",
  null
  
)

export default component.exports